import {NgModule} from '@angular/core';
import {CommonModule, DecimalPipe} from '@angular/common';
import {ComponentsModule} from '../../components/components.module';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import {httpLoaderFactory} from '../../app.module';
import {CdkDrag, CdkDragHandle, DragDropModule} from '@angular/cdk/drag-drop';
import {MatDialogModule} from '@angular/material/dialog';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {BrowserModule} from '@angular/platform-browser';
import {Check, Clock3, LucideAngularModule} from 'lucide-angular';
import {MatListModule} from '@angular/material/list';
import {AppContractFormComponent} from './controller/contract-form/contract-form.component';
import {MatGridListModule} from '@angular/material/grid-list';
import {AppContractStepComponent} from './components/contract-step/contract-step.component';
import {AppContractRoadmapComponent} from './components/contract-roadmap/contract-roadmap.component';
import {AppContractStepDocumentComponent} from './components/contract-step-document/contract-step-document.component';
import {
    AppContractStepCreditLetterComponent
} from './components/contract-step-credit-letter/contract-step-credit-letter.component';
import {
    AppContractStepMultiPaymentComponent
} from './components/contract-step-multi-payment/contract-step-multi-payment.component';
import {
    AppContractStepSubContractComponent
} from './components/contract-step-subcontract/contract-step-subcontract.component';
import {AppContractRoadmapMenuComponent} from './components/contract-menu-roadmap/contract-roadmap-menu.component';
import {AppContractContextMenuComponent} from './components/contract-menu-context/contract-context-menu.component';
import {CdkMenuModule} from '@angular/cdk/menu';
import {AppContractStepNameComponent} from './components/contract-name-edit-step/contract-step-name-edit.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {AppContractPartiesBlockComponent} from './components/contract-block-parties/contract-parties-block.component';
import {AppContractFinanceBlockComponent} from './components/contract-block-finance/contract-block-finance.component';
import {
    AppContractProductsBlockComponent
} from './components/contract-block-bank-products/contract-block-bank-products.component';
import {
    AppContractStepTargetSelectComponent
} from './components/contract-step-target-select/contract-step-target-select.component';
import {
    AppcontractStepPaymentEditComponent
} from './components/contract-step-payment-edit/contract-step-payment-edit.component';
import {AppContractStepPaymentComponent} from './components/contract-step-payment/contract-step-payment.component';
import {MatSelectModule} from '@angular/material/select';
import {AppContractPartySelectComponent} from './components/contract-party-select/contract-party-select.component';
import {
    AppContractStepPaymentViewComponent
} from './components/contract-step-payment-view/contract-step-payment-view.component';
import {MatRadioModule} from '@angular/material/radio';
import {
    AppContractBlockFinanceWalletSelectComponent
} from './components/contract-block-finance-wallet-select/contract-block-finance-wallet-select.component';
import {AppContractStepTaskComponent} from './components/contract-step-task/contract-step-task.component';
import {
    AppContractStepCLViewComponent
} from './components/contract-step-credit-letter-view/contract-step-credit-letter-view.component';
import {AppGraphKonvaModule} from '../graph-konva/app.graph-konva.module';
import {RoadmapGraphComponent} from './components/roadmap-graph/roadmap-graph.component';
import {MatButtonToggle, MatButtonToggleGroup} from '@angular/material/button-toggle';
import {MatTooltip} from '@angular/material/tooltip';
import {AppContractHistoryListComponent} from './components/contract-history-list/contract-history-list.component';
import {AppMaterialModule} from '../../app.material.module';
import {
    AppContractBlockBankProductsRequestComponent
} from './components/contract-block-bank-products-request-form/contract-block-bank-products-request-form';

@NgModule({
    declarations: [
        AppContractFormComponent,
        AppContractRoadmapComponent,
        AppContractStepComponent,
        AppContractStepDocumentComponent,
        AppContractStepCreditLetterComponent,
        AppContractStepTaskComponent,
        AppContractStepPaymentComponent,
        AppContractStepMultiPaymentComponent,
        AppContractStepSubContractComponent,
        AppContractRoadmapMenuComponent,
        AppContractContextMenuComponent,
        AppContractStepNameComponent,
        AppContractPartiesBlockComponent,
        AppContractFinanceBlockComponent,
        AppContractProductsBlockComponent,
        AppContractStepTargetSelectComponent,
        AppcontractStepPaymentEditComponent,
        AppContractPartySelectComponent,
        AppContractStepPaymentViewComponent,
        AppContractBlockFinanceWalletSelectComponent,
        AppContractStepCLViewComponent,
        AppContractHistoryListComponent,
        RoadmapGraphComponent,
        AppContractBlockBankProductsRequestComponent,
    ],
    imports: [
        AppGraphKonvaModule,
        MatRadioModule,
        MatGridListModule,
        CommonModule,
        ComponentsModule,
        AppMaterialModule,
        BrowserModule,
        FormsModule,
        CdkDrag,
        CdkDragHandle,
        DragDropModule,
        MatIconModule,
        CdkMenuModule,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule,
        MatListModule,
        MatDatepickerModule,
        MatDialogModule,
        MatSelectModule,
        MatButtonToggle,
        MatButtonToggleGroup,
        MatTooltip,
        LucideAngularModule.pick({
            Check, Clock3

        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: httpLoaderFactory,
                deps: [HttpClient],
            },
            defaultLanguage: 'ru',
        })
    ],

    exports: [
        AppContractFormComponent,
        AppContractStepComponent,
        RoadmapGraphComponent,
    ],
    providers: [
        DecimalPipe
    ],
})
export class AppContractModule {
}
